module.exports = __webpack_public_path__ + "flyer_background_baby_layflat_white_099-5424959a69a2688f6c21ce4202dce59e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_baby_layflat_white_099.jpg
// module id = 1601
// module chunks = 1